var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"top-of-page"}},[_c('div',{staticClass:"header-container"},[_c('div',{staticClass:"header-text"},[_vm._v("Phantasy Phootball")])])])
}]

export { render, staticRenderFns }